import { getProtocolStaticMarkets } from "./get-protocol-static-markets";
import { setProtocolStaticMarkets } from "./set-protocol-static-markets";
import { BlobClientError } from "./types";

export const BlobClient = {
  BlobClientError,

  getProtocolStaticMarkets,
  setProtocolStaticMarkets,
};
